var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.939428 19.5462C0.658221 19.2649 0.500248 18.8834 0.500248 18.4857C0.500248 18.0879 0.658221 17.7065 0.939429 17.4252L8.36443 10.0002L0.93943 2.57517C0.666193 2.29227 0.515001 1.91336 0.518419 1.52007C0.521836 1.12677 0.67959 0.750554 0.957701 0.472442C1.23581 0.194329 1.61203 0.0365782 2.00533 0.0331603C2.39862 0.0297424 2.77753 0.180934 3.06043 0.454171L11.5459 8.93967C11.8271 9.22096 11.9851 9.60243 11.9851 10.0002C11.9851 10.3979 11.8271 10.7794 11.5459 11.0607L3.06043 19.5462C2.77914 19.8274 2.39767 19.9854 1.99993 19.9854C1.60218 19.9854 1.22072 19.8274 0.939428 19.5462Z",
    fill: "#151516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.61b2a54d35fb1c389abf50222a664d70.svg";
export { ForwardRef as ReactComponent };